// extracted by mini-css-extract-plugin
export default {"xs":"374px","sm":"740px","md":"1024px","lg":"1280px","xl":"1680px","wrapper":"QRIYK1UIuYRrNIM44xPk","modalWrapper":"ZndegsQQPIVcSoccH_AM","loadingWrapper":"OScknZIy1ocf9eaZgGkK"};